import React, { useEffect, useState } from "react";
import translation from "~/i18n";

// Components
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import { Case, If } from "~/common/components/If";
import useAlert from "~/common/hooks/useAlert";
import TabMenu from "~/common/components/TabMenu";

// Assets
import "~/assets/sass/pages/invest/IrModal/common.scss";
import LightDefaultProfileImg from "~/assets/img/defaultImg/light-profile-large.png";
import DarkDefaultProfileImg from "~/common/components/Images";

import { IconDownload, IconVideo, PrintIcon, SingleArrowIcon } from "~/assets/svg/InterfaceIcon";
import { SolidCloseIcon } from "~/assets/svg/CloseIcon";

// Pages
import BasicInfoView from "~/pages/investment/InvestEvalPage/detail/modal/basicInfo";
import HistoryView from "~/pages/investment/InvestEvalPage/detail/modal/history";
import MemberView from "~/pages/investment/InvestEvalPage/detail/modal/member";
import ShareholderView from "~/pages/investment/InvestEvalPage/detail/modal/shareholder";
import FinanceView from "~/pages/investment/InvestEvalPage/detail/modal/finance";
import ProductView from "~/pages/investment/InvestEvalPage/detail/modal/product";
import OutcomeView from "~/pages/investment/InvestEvalPage/detail/modal/outcome";
import AlertTemplate from "~/common/components/AlertPortal/AlertTemplate";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import { useNavigate } from "react-router";
import { Trans, useTranslation } from "react-i18next";
import { useGlobalStore } from "~/store";

const IrDetailModal = ({
	evalStatus,
	IrModal,
	setIrModal,
	irInfo,
	info,
	company,
	investInfo,
	param,
	irDetailRequest,
}) => {
	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();
	const { t } = useTranslation();
	const [currentTab, setCurrentTab] = useState("basicInfo");
	const [judgeCompleteChkAlert, setJudgeCompleteAlertChkAlert] = useState(false);
	const [judgeCompleteAlert, setJudgeCompleteAlertAlert] = useState(false);
	const [showPrintAlert, PrintAlert] = useAlert();
	const [judgeCmtWarning, setJudgeCmtWarning] = useState(false);
	const [itemScore, setItemScore] = useState({});
	const [calculatedScore, setCalculatedScore] = useState({});
	const [scoreSend, setScoreSend] = useState({});
	const [totalScore, setTotalScore] = useState(0);
	const irEvaluateRequest = useRequest("get", "/vc/invest/ir/detail/" + param.idx);
	const irEvaluateForm = useRequest("post", "/vc/invest/ir/evaluate/" + param.idx);
	const navigate = useNavigate();
	const [comment, setComment] = useState("");

	const tabMenuList = [
		{
			id: "basicInfo",
			title: translation.t(
				"pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.tabMenuList.title01"
			),
		},
		{
			id: "history",
			title: translation.t(
				"pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.tabMenuList.title02"
			),
		},
		{
			id: "member",
			title: translation.t(
				"pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.tabMenuList.title03"
			),
		},
		{
			id: "shareholder",
			title: translation.t(
				"pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.tabMenuList.title04"
			),
		},
		{
			id: "finance",
			title: translation.t(
				"pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.tabMenuList.title05"
			),
		},
		{
			id: "product",
			title: translation.t(
				"pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.tabMenuList.title06"
			),
		},
		{
			id: "outcome",
			title: translation.t(
				"pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.tabMenuList.title07"
			),
		},
	];

	const userSelected = investInfo?.Judge?.find((d) => d.userIdx === info.idx);
	const [finalData, setFinalData] = useState([]);
	useEffect(() => {
		const score =
			Object.values(calculatedScore).length === 0 ? [0] : Object.values(calculatedScore);
		const total = score.reduce((acc, cur) => {
			acc = acc + cur;
			return acc;
		});
		setTotalScore(total);
	}, [calculatedScore]);

	const irBasicInfo = irInfo?.IRBasicInfo;
	const irFinance = irInfo?.IRFinance;
	const irHistory = irInfo?.IRHistory;
	const irMember = irInfo?.IRMember;
	const irOutcome = irInfo?.IROutcome;
	const irProduct = irInfo?.IRProduct;
	const irShareholder = irInfo?.IRShareholder;

	const handleScore = (e, catIdx, itemIdx, scoreIdx) => {
		const score = parseInt(e.target.value.replace(/\D/, ""));

		const scoreKey = catIdx.toString() + "-" + itemIdx.toString();
		const targetCate = investInfo?.Review?.Category?.find((d) => d.idx === catIdx);
		const targetWeight = parseInt(targetCate.weight);

		//최종 데이터 갖고있기
		const changeScore = {
			idx: scoreIdx ? scoreIdx : null,
			categoryIdx: catIdx,
			itemIdx: itemIdx,
			score: isNaN(score) ? 0 : score,
		};

		//중복된 값 빼주기
		const tmpData = finalData.filter(
			(list) =>
				list.categoryIdx.toString() + "-" + list.itemIdx.toString() !==
				changeScore.categoryIdx.toString() + "-" + changeScore.itemIdx.toString()
		);
		const insertData = [...tmpData, changeScore];
		setFinalData(insertData);

		const itemNum = targetCate?.Item.length;
		const calScore = (score / (10 * itemNum)) * targetWeight;

		if (score > 10 || isNaN(score) || score === "") {
			setItemScore({
				...itemScore,
				[scoreKey]: 0,
			});
			setCalculatedScore({
				...calculatedScore,
				[scoreKey]: 0,
			});
		} else {
			setItemScore({
				...itemScore,
				[scoreKey]: score,
			});
			setCalculatedScore({
				...calculatedScore,
				[scoreKey]: calScore,
			});
			setScoreSend({
				...scoreSend,
				[scoreKey]: { categoryIdx: catIdx, itemIdx: itemIdx },
			});
		}
	};

	const judeFinish = () => {
		if (!comment) {
			setJudgeCmtWarning(true);
		} else {
			const dataForm = {
				comment: comment,
				scores: finalData,
				totalScore: totalScore,
			};
			irEvaluateForm.call(dataForm);
		}
	};

	useEffect(() => {
		let CalScore = [];

		investInfo?.Review?.Category?.map((d) => {
			d.Item &&
				d.Item.map((s) => {
					if (s.score) {
						const scoreKey = s.score.categoryIdx
							? s.score.categoryIdx.toString() + "-" + s.score.itemIdx.toString()
							: 0;
						const targetCate = investInfo?.Review?.Category?.find(
							(d) => d.idx === s.score.categoryIdx
						);

						const targetWeight = parseInt(targetCate.weight);
						const itemNum = targetCate?.Item.length;
						const calScore = (s.score.score / (10 * itemNum)) * targetWeight;

						CalScore = {
							...CalScore,
							[scoreKey]: calScore,
						};
					}
				});
		});

		setCalculatedScore({
			...calculatedScore,
			...CalScore,
		});
	}, [investInfo]);

	useEffect(() => {
		let tmpScore = [];
		setComment(userSelected?.comment);
		const mappedData =
			investInfo?.Review?.Category.map((data, index) =>
				data.Item.map((data2, index2) => {
					return { itemIdx: data2.idx, categoryIdx: data.idx, idx: null, score: 0 };
				})
			) ?? [];
		setFinalData(...mappedData);
		userSelected?.Score.map((d) => {
			const scoreKey = d.categoryIdx + "-" + d.itemIdx;

			tmpScore = {
				...tmpScore,
				[scoreKey]: d.score,
			};
			return null;
		});
		setTotalScore(userSelected?.totalScore);
		setItemScore({
			...itemScore,
			...tmpScore,
		});
	}, [userSelected]);

	useEffect(() => {
		switch (irEvaluateForm.state) {
			case API_STATE.done:
				navigate(`/invest/evaluate/detail/${param.idx}`);
				window.location.reload();
				break;
			case API_STATE.error:
				console.log("irEvaluateForm Error");
				break;
			default:
				break;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [irEvaluateForm.state, irEvaluateForm.response, irEvaluateForm.error]);

	useEffect(() => {
		switch (irEvaluateRequest.state) {
			case API_STATE.done:
				setJudgeCompleteAlertAlert(true);
				break;
			case API_STATE.error:
				console.log(" finalData error >> ", irEvaluateRequest.error);
				break;
			default:
				break;
		}
	}, [irEvaluateRequest.state, irEvaluateRequest.response, irEvaluateRequest.error]);

	const openNewTab = (url) => {
		window.open(url);
	};

	const handleCloseBtn = () => {
		setCurrentTab("basicInfo");
		setIrModal(false);
	};

	const checkPrintAlert = () => {
		const hideUntil = localStorage.getItem("hideUntil");

		if (!hideUntil)
			showPrintAlert().then(() => {
				window.print();
			});
		else if (hideUntil) {
			const hideUntilDate = new Date(hideUntil);
			const currentDate = new Date();

			if (currentDate < hideUntilDate) {
				window.print();
			} else {
				showPrintAlert().then(() => {
					window.print();
				});
			}
		}
	};

	// 인쇄 안내창
	const hidePrintAlertHandler = (e) => {
		if (!e.target.checked) {
			localStorage.removeItem("hideUntil");
		} else {
			const currentDate = new Date();
			const hideUntilDate = new Date();
			hideUntilDate.setDate(currentDate.getDate() + 7);
			localStorage.setItem("hideUntil", hideUntilDate);
		}
	};

	return (
		<>
			<ModalTemplate
				modalState={IrModal}
				setModalToggle={setIrModal}
				width={1470}
				height={472}
				className="ir-modal"
			>
				<div className="modal-content">
					<section className="irModal-detail-body">
						<div className="top">
							<h3 className="header-title">
								{t(
									"pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.title"
								)}
							</h3>
							<button type="button" className="modal-close" onClick={handleCloseBtn}>
								<SolidCloseIcon />
							</button>
							<div className="btn-wrapper">
								<button
									type="button"
									className="btn__outline"
									color="primary"
									disabled={
										investInfo?.promotionUrl === "" ||
										investInfo?.promotionUrl === null
									}
									onClick={() => openNewTab(investInfo?.promotionUrl)}
								>
									<IconVideo />
									{t(
										"pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.button01"
									)}
								</button>
								<button
									type="button"
									className="btn__outline"
									color="primary"
									disabled={
										investInfo?.businessPlan === "" ||
										investInfo?.businessPlan === null
									}
									onClick={() => openNewTab(investInfo?.businessPlan)}
								>
									<IconDownload />
									{t(
										"pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.button02"
									)}
								</button>
								<button
									type="button"
									className="btn__outline circle"
									color="primary"
									onClick={checkPrintAlert}
								>
									<PrintIcon />
								</button>
							</div>
						</div>
						<TabMenu
							tabItem={tabMenuList}
							currentTab={currentTab}
							setCurrentTab={setCurrentTab}
						/>
						<div className="scroll-wrap">
							<If condition={currentTab}>
								<Case condition={"basicInfo"}>
									<BasicInfoView {...{ irBasicInfo }} />
								</Case>
								<Case condition={"history"}>
									<HistoryView {...{ irHistory }} />
								</Case>
								<Case condition={"member"}>
									<MemberView {...{ irMember }} />
								</Case>
								<Case condition={"shareholder"}>
									<ShareholderView {...{ irShareholder }} />
								</Case>
								<Case condition={"finance"}>
									<FinanceView {...{ irFinance }} />
								</Case>
								<Case condition={"product"}>
									<ProductView {...{ irProduct }} />
								</Case>
								<Case condition={"outcome"}>
									<OutcomeView {...{ irOutcome }} />
								</Case>
							</If>
						</div>
					</section>
					<section className="irModal-evaluate-body">
						<div className="judge-form-top">
							<div className={"img-wrap"}>
								<img
									src={
										info.img ||
										(theme === "dark"
											? DarkDefaultProfileImg
											: LightDefaultProfileImg)
									}
									alt={t(
										"pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.imageAlt"
									)}
								/>
							</div>
							<dl className="judging-vc">
								<dt>{company.name}</dt>
								<dd>{info.name}</dd>
							</dl>
							<div className="judging-vc-score">
								<Trans
									i18nKey="pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.score"
									components={[<b />, { totalScore: totalScore?.toFixed(2) }]}
								/>
							</div>
						</div>
						<div className="scroll-wrap">
							<form className="c__form judge-form">
								{investInfo?.Review?.Category?.map((d) => (
									<div className="judge-detail-item" key={d.idx}>
										<div className="category-title">
											{d.title}
											<span>
												<Trans
													i18nKey="pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.categoryTitle"
													components={[{ d }]}
												/>
											</span>
										</div>
										{d.Item?.map((item, itemIdx) => {
											// userSelected
											return (
												<div className="f__group" key={item.idx}>
													<div className="f__label">
														{itemIdx + 1}. {item.content}
													</div>
													<div className="f__control">
														<input
															className="c__input"
															onChange={(e) =>
																handleScore(
																	e,
																	d.idx,
																	item.idx,
																	item.score
																		? item.score.idx
																		: null
																)
															}
															value={
																itemScore[
																	d.idx.toString() +
																		"-" +
																		item.idx.toString()
																] || 0
															}
														/>
													</div>
												</div>
											);
										})}
									</div>
								))}
								{/* 시험용 */}
								{/* <div className="judge-detail-item" >
										<div className="category-title">
											fdfdsfsd <span>※ 60 최대점</span>
										</div>
					
											<div className="f__group">
												<div className="f__label">fdsafdsa</div>
												<div className="f__control">
													<input 
														className="c__input" 
														onChange={(e) => handleScore(e, 0, 1)} 
														value={itemScore[0 + "-" + 1] || 0} 
													/>
												</div>
											</div>
											<div className="f__group">
												<div className="f__label">fdsafdsa</div>
												<div className="f__control">
													<input 
														className="c__input" 
														onChange={(e) => handleScore(e, 0, 2)} 
														value={itemScore[0 + "-" + 2] || 0} 
													/>
												</div>
											</div>
											<div className="f__group">
												<div className="f__label">fdsafdsa</div>
												<div className="f__control">
													<input 
														className="c__input" 
														onChange={(e) => handleScore(e, 0, 3)} 
														value={itemScore[0 + "-" + 3] || 0} 
													/>
												</div>
											</div>
									</div> */}
								<div className="judge-commentary">
									{/* <Form useForm={judgeCommentaryForm} className="vertical">
										<Textarea
											label="심사평"
											name="judgeCommentary"
											value={comment}
											
										/>
									</Form> */}
									<textarea
										value={comment}
										onChange={(e) => setComment(e.target.value)}
										className="c__textarea"
									/>
								</div>
							</form>
						</div>
						<div className="modal-footer">
							<button
								type="button"
								className="btn__solid"
								color="primary"
								onClick={() => setJudgeCompleteAlertChkAlert(true)}
							>
								{evalStatus ===
									translation.t(
										"pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.foot.status01"
									) ||
								evalStatus ===
									translation.t(
										"pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.foot.status02"
									)
									? translation.t(
											"pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.foot.button01"
									  )
									: translation.t(
											"pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.foot.button02"
									  )}
							</button>
						</div>
					</section>
				</div>
			</ModalTemplate>

			{/*-----------심사하기 모달 - 심사완료 Alert */}
			<AlertTemplate
				alertModalState={judgeCompleteAlert}
				setAlertModalToggle={setJudgeCompleteAlertAlert}
				width={420}
				height={230}
				alertType="success"
			>
				<p className="alert-content">
					<div className="modal-text">
						{t(
							"pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.alert01"
						)}
					</div>
				</p>
				<div className="alert-footer">
					<button
						className="btn__solid"
						color="primary"
						onClick={() => {
							setJudgeCompleteAlertAlert(false);
							setJudgeCompleteAlertChkAlert(false);
							setIrModal(false);
							irDetailRequest.singleCall(param.idx, "path");
						}}
					>
						{t(
							"pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.confirm"
						)}
					</button>
				</div>
			</AlertTemplate>

			{/*-----------심사하기 모달 - 심사완료 확인 Alert */}
			<AlertTemplate
				alertModalState={judgeCompleteChkAlert}
				setAlertModalToggle={setJudgeCompleteAlertChkAlert}
				width={420}
				height={230}
				alertType="info"
			>
				<p className="alert-content">
					<div className="modal-text">
						{t(
							"pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.alert02"
						)}
					</div>
				</p>
				<div className="alert-footer">
					<button className="btn__solid" color="primary" onClick={judeFinish}>
						{t(
							"pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.confirm"
						)}
					</button>
					<button
						className="btn__solid"
						color="gray"
						onClick={() => setJudgeCompleteAlertChkAlert(false)}
					>
						{t(
							"pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.reject"
						)}
					</button>
				</div>
			</AlertTemplate>

			{/* 프린트 안내창 */}
			<PrintAlert
				type="info"
				className="print-alert-modal"
				layout="horiz"
				width={420}
				height={330}
				message={
					<>
						<h3 className="print-title-wrap">
							아래와 같은 설정을 하셔야
							<br />
							정상적으로 인쇄할 수 있습니다.
						</h3>
					</>
				}
				desc={
					<>
						<div className="desc-box">
							<div className="desc-title">깃발 인쇄 설정 방법</div>
							<p className="desc-content">
								설정 더보기 <SingleArrowIcon /> 배율 : 맞춤 설정 클릭 후 50 입력
							</p>
						</div>
						<div className="checkbox">
							<label className={`checkbox-custom`}>
								<input onChange={hidePrintAlertHandler} type="checkbox" />
								<span className="checkmark" />
								<span className="checkbox-label">일주일 동안 보지 않기</span>
							</label>
						</div>
					</>
				}
				confirm="확인"
			/>

			<AlertTemplate
				alertModalState={judgeCmtWarning}
				setAlertModalToggle={setJudgeCmtWarning}
				width={420}
				height={230}
				alertType="info"
			>
				<p className="alert-content">
					<div className="modal-text">
						{t(
							"pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.alert03"
						)}
					</div>
				</p>
				<div className="alert-footer">
					<button
						className="btn__solid"
						color="primary"
						onClick={() => {
							setJudgeCmtWarning(false);
							setJudgeCompleteAlertChkAlert(false);
						}}
					>
						{t(
							"pages.investment.InvestEvalPage.detail.Step.modalForJudge.IrDetailModal.confirm2"
						)}
					</button>
				</div>
			</AlertTemplate>
		</>
	);
};

export default IrDetailModal;
